export default __webpack_public_path__ + "static/blob12-7807b622ad69b7400dab39994778ceb0.svg";